import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'

import PageTitle from './PageTitle';
import ErrorDisplay from './ErrorDisplay';
import Waiting from './Waiting';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import clsx from 'clsx';
import useStyles from '../styles/Styles'

import { makeRequest, resetErrorMessage, resetLogoutFailure } from '../actions';

const Logout= () => {
	const init = useSelector(state => state.requests.init);
	const dispatch = useDispatch();
	const logoutError = useSelector(state => state.requests.logout_error);
	const cart = useSelector(state => state.cart.data);
	const timedOut = useSelector(state => state.timedOut);
	
	const navigate = useNavigate();
	const classes = useStyles();
	
	const [submitting, setSubmitting] = useState(false);
	
	useEffect(() => {
		if(logoutError){
			setSubmitting(false);
		}
	}, [logoutError])
	
	const doLogout = (event) => {
		event.preventDefault();
		setSubmitting(true);
		dispatch(resetErrorMessage());
		dispatch(resetLogoutFailure());
		dispatch(makeRequest('logout', null));
	}
	
	useEffect(() => {
		if(init && (timedOut || cart.length === 0)){
			setSubmitting(true);
			dispatch(makeRequest('logout', timedOut));
		} // eslint-disable-next-line
	}, [dispatch, init])
	
	return (
		<>
		<ErrorDisplay />
		<Paper className={clsx(classes.innerContent, classes.page)} square={true}>
		<PageTitle title='Log out' />
		{ init ? (submitting ? 
		<Waiting 
			message={timedOut ? 'Logging you out due to inactivity' : 'Logging out...'} 
		/> :
		<>
		{cart.length > 0 ? 
		<>
		<Typography gutterBottom color='error'>Warning: You have not checked out.</Typography>
		<Typography paragraph>There are still one or more items in your cart. 
		To complete your enrolment, you must check out.
		</Typography>
		<Grid container spacing={2}>
		<Grid item>
		<Button color="primary"
			onClick={() => navigate('/cart')}
			>View cart</Button>
		</Grid>
		<Grid item xs>
		<Button
			type="submit"
			fullWidth
			variant="contained"
			color="primary"
			className={classes.submit}
			onClick={(event) => doLogout(event)}
		>Log out
		</Button>
		</Grid>
		</Grid>
		</>
		:
		<Button
			type="submit"
			fullWidth
			variant="contained"
			color="primary"
			className={classes.submit}
			onClick={(event) => doLogout(event)}
		>Log out
		</Button>
		}
		</>
		) : null }
		</Paper>
		</>
	)};

export default Logout